import styles from "./styles.module.scss";
import { YMaps, Map, Placemark } from "@pbe/react-yandex-maps";

export const MapWrap = () => {
  const placeMark = {
    geometry: [56.471273, 84.944154],
    properties: {
      balloonContent: `<b>Телефон:</b> 8 (3822) 901-101 доб. 1982<br/><b>Почта:</b> cyberfit@ssmu.ru`,
    },
  };
  return (
    <section id="map">
      <div className={styles.Map}>
        <YMaps>
          <Map
            width={"100%"}
            height={300}
            state={{ center: [56.471273, 84.944154], zoom: 17 }}
          >
            <Placemark {...placeMark} modules={["geoObject.addon.balloon"]} />
          </Map>
        </YMaps>
      </div>
    </section>
  );
};
